import { MultigameParams } from "../../MultigameParams";
import { SlotGameInitData } from "../../SlotGameInitData";
import { SweetSweet_ResponsivePIXIApp } from "../SweetSweet/game_ResponsivePIXIApp";

export class SweetSweetLink_ResponsivePIXIApp extends SweetSweet_ResponsivePIXIApp {

    constructor(multigameParams: MultigameParams, initData: SlotGameInitData) {
        super(multigameParams, initData, "SweetSweetLink");
    }

}
